/**
 * Get offset of element relative to document.
 * 
 * @param {element} el 
 * @return {Object} The top and left offset of the element relative to the document
 */
export function getElementOffset(el) {
    let top = 0;
    let left = 0;
    let element = el;

    // Loop through the DOM tree
    // and add it's parent's offset to get page offset
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top,
        left
    };
}

/**
 * Updates the parameter in provided URL.
 * 
 * @param {string} originalUrl
 * @param {object} params
 * @returns {string}
 */
export function updateUrlParameters(params, originalUrl) {
    const url = new URL(originalUrl?.toString() || window.location.toString());

    for (const [key, value] of Object.entries(params)) {
      if (!value) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value.toString());
      }
    }

    return url.toString();
  }

/**
 * Updates the parameter in current URL.
 * 
 * @param {string} name
 */
export function removeParameterFromUrl(name) {
    let url = new URL(window.location.toString());

    url.searchParams.delete(name);
    
    window.history.replaceState({path: url.toString()}, '', url.toString());
}

export function setContentHeight() {
    const headerElement = document.querySelector('.header-wrapper');
    const headerBottom = headerElement.offsetTop + headerElement.offsetHeight;
    document.querySelector(':root').style.setProperty('--content-height', window.innerHeight - headerBottom + 'px');
}

export function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

/**
 * Wrapper for Object.fromEntries to work on older browsers
 */
export const fromEntries = Object.fromEntries||function(e){for(var r,n=("entries"in e?e.entries():e),t={};(r=n.next())&&!r.done;){var i=r.value;Object.defineProperty(t,i[0],{configurable:!0,enumerable:!0,writable:!0,value:i[1]})}return t};

export const composeProductImageUrl = () => {
    const fileURL = window.theme.filesURL.replace(/[^\/]+$/, '')
    return fileURL.substring(0, fileURL.lastIndexOf('files'))
}

export function waitForElement (selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector))
        }
  
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
            observer.disconnect()
            resolve(document.querySelector(selector))
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    })
}